/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Outlook_Humanize_Tone_ConciseInputs */



/**
* | output |
* | --- |
* | "Concise" |
*
* @param {Chat_Outlook_Humanize_Tone_ConciseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_outlook_humanize_tone_concise = /** @type {((inputs?: Chat_Outlook_Humanize_Tone_ConciseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Outlook_Humanize_Tone_ConciseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Knapp")
	return /** @type {LocalizedString} */ ("Concise")
});